<template>
  <div id="app" class="app">
    <div class="row" ref="pcMenu">
      <div class="row bar">
        <div class="container">
          <div class="left">{{localLocale.format('LLLL')}}</div>
          <div class="langbar right">
            <ul class="flex_row">
              <li v-for="(item,index) in langList" :key="index" @click="langType(item.name)">{{item.lang}}</li>
              <!-- <li>{{$store.state.user}}</li> -->
              <li v-if="$store.state.user.id">
                <el-dropdown>
                  <span class="el-dropdown-link flex_row" style="cursor:pointer;">
                    <img src="@/../static/images/login/me.png" alt="" srcset="" style="margin-right:7px">
                    {{$store.state.user.realName}}
                    <i class="el-icon-caret-bottom el-icon--right" style="color:#CCCCCCFF;font-size: 2rem;"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <div class="flex_row" @click="$refs.HeaderNav.exit()">
                        <img src="@/../static/images/login/exit.png" alt="" srcset="" style="margin-right:7px"> 退出登录
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div @click="$refs.HeaderNav.go('personal')" class="flex_row">
                        <img src="@/../static/images/login/me.png" alt="" srcset="" style="margin-right:7px"> 个人中心
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <!-- <HeaderNav :days='dateInfo.days'></HeaderNav> -->
      <div class="row logoBar">
        <div class="container">
          <div>
            <HeaderNav :data='dateInfo' ref="HeaderNav"></HeaderNav>
          </div>
          <div class="logoBox" v-if="false">
            <div class="col-xs-6 col-sm-8 col-md-8">
              <img :src="logo" />
            </div>
            <div class="col-xs-6 col-sm-4 col-md-3 date right">
              <!-- 夏洽会 -->
              <div v-if="dateInfo.type == 0" style="line-height: 30px;">
                <div>第二十一届投洽会</div>
                距开幕还有<span style="font-size: 30px;">{{dateInfo.days}}</span>天
              </div>
              <div v-if="dateInfo.type==1" style="color: red;font-size: 20px;">{{dateInfo.year}}投洽会<br />今天隆重开幕！</div>
              <div v-if="dateInfo.type==2" style="color: red;font-size: 20px;">今天是{{dateInfo.year}}投洽会<br />开幕的第{{dateInfo.days}}天！</div>
              <div v-if="dateInfo.type==3" style="color: red;font-size: 20px;">热烈祝贺{{dateInfo.year}}投洽会<br />成功闭幕！</div>
              <!-- 投洽会 -->
              <div v-if="dateInfo.type == 10" style="line-height: 30px;">
                <div>距第{{dateInfo.year}}届投洽会</div>
                <div>距开幕</div>
                还有<span style="font-size: 30px;">{{dateInfo.days}}</span>天
              </div>
              <div v-if="dateInfo.type==11" style="color: red;font-size: 20px;">第{{dateInfo.year}}届投洽会<br />今天隆重开幕！</div>
              <div v-if="dateInfo.type==12" style="color: red;font-size: 20px;">今天是第{{dateInfo.year}}届投洽会<br />开幕的第{{dateInfo.days}}天！</div>
              <div v-if="dateInfo.type==13" style="color: red;font-size: 20px;">热烈祝贺第{{dateInfo.year}}届投洽会<br />成功闭幕！</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- pc端菜单 -->
    <div class="pcMenuHeight" style="width:100%;height: 60px;" v-if="BarFixed"></div>
    <div class="row menuBar" :class="{'BarFixed' : BarFixed}" id="BarFixed">
      <div class="container">
        <div class="pcMenu">
          <!-- <ul class="pcMenuUl clearfix">
                    <li v-for="(mItem, mid) in pcMenu" :key="mid" :class="{'active': $route.path.indexOf(mItem.link) !== -1}" @click.stop="menuHandle(mItem,mid)">
                        <span v-if="mItem.name == '国际投资论坛'"><a href="https://www.chinafair.org.cn/iiforum/#/" target="_blank" class="pclink">{{mItem.name}}</a></span>
                        <span v-else>{{mItem.name}}</span>
                        <ul class="subUl">
                            <li v-for="(subItem, subId) in mItem.subMenu" :key="subId" :class="{'active': ($route.path.indexOf(subItem.subLink) !== -1) && ($route.query.name.indexOf(subItem.subName) !== -1)}" @click.stop="subMenuHandle(subItem)"><i>{{subItem.subName}}</i></li>
                        </ul>
                    </li>
                 
                </ul> -->
          <ul class="pcMenuUl clearfix" v-if="$route.path=='/HotProject' ||$route.name=='BusinessProject' ||$route.name=='BusinessProjectDetail'">

            <li v-for="(mItem, mid) in pcMenu" :key="mid" :class="{ active:  mItem.link=='CloudFairIndex'}" @click.stop="menuHandle(mItem, mid)">
              <!-- <span v-if="mItem.name == '国际投资论坛'"><a href="https://www.chinafair.org.cn/iiforum/#/" target="_blank" class="pclink">{{ mItem.name }}</a></span> -->
              <span>{{ mItem.name }}</span>
              <ul class="subUl">
                <li v-for="(subItem, subId) in mItem.subMenu" :key="subId" :class="{
                            active:
                            ($route.path.indexOf(subItem.subLink) !== -1 &&
                            $route.query.name.indexOf(subItem.subName) !== -1) || flagItem
                        }" @click.stop="subMenuHandle(subItem)">
                  <i>{{ subItem.subName }}</i>
                </li>
              </ul>
            </li>

          </ul>

          <ul class="pcMenuUl clearfix" v-else>
            <li v-for="(mItem, mid) in pcMenu" :key="mid" :class="{ active: $route.path.indexOf(mItem.link) !== -1 }" @click.stop="menuHandle(mItem, mid)">
              <!-- <span v-if="mItem.name == '国际投资论坛'"><a href="https://www.chinafair.org.cn/iiforum/#/" target="_blank" class="pclink">{{ mItem.name }}</a></span> -->
              <span>{{ mItem.name }}</span>
              <ul class="subUl">
                <li v-for="(subItem, subId) in mItem.subMenu" :key="subId" :class="{
                            active:
                            ($route.path.indexOf(subItem.subLink) !== -1 &&
                            $route.query.name.indexOf(subItem.subName) !== -1) || flagItem
                        }" @click.stop="subMenuHandle(subItem)">
                  <i>{{ subItem.subName }}</i>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </div>
    </div>
    <!-- 移动端菜单 -->
    <div class="mMenu" v-if="mShow">
      <ul>
        <li :class="{'active': $route.path.indexOf(mobileMenu.link) !== -1}" v-for="(mobileMenu,mIdx) in pcMenu" :key="mIdx" @click.stop="mMenuHandle(mobileMenu)">{{mobileMenu.name}}</li>
        <!-- <li><a href="http://www.chinafair.org.cn/CifitSystem/newapp.html" target="_blank" class="mobilelink">云上投洽会</a></li> -->
      </ul>
    </div>
    <div class="row mobilemenuBar mobileFixed">
      <!-- <div class="col-xs-2 col-sm-2"><img id="mMenu" src="../static/images/menu.png"/></div>
        <div class="col-xs-7 col-sm-7 mobile-img noPadding"><img :src="logo"/></div>
        <div class="col-xs-3 col-sm-3" style="padding-right: 0px;">
            <select class="sellang" v-model="selected" @change="mobilelangType">
                <option v-for="(item,index) in langList" :key="index" :value="item.name">{{item.lang}}</option>
            </select>
        </div> -->
      <HeaderNav :data='dateInfo' ref="HeaderNav"></HeaderNav>
    </div>
    <div class="mobileMenuHeight" style="width:100%;height: 58px;"></div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <server-bar></server-bar>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav/HeaderNav'

import FooterBar from '@/components/FooterBar/FooterBar'
import serverBar from '@/components/ServerBar/ServerBar'
var moment = require('moment');
moment.locale('zh-cn');
export default {
  name: 'App',
  components: {
    FooterBar,
    serverBar,
    HeaderNav
  },
  data () {
    return {
      a: false,
      flagItem: false,
      localLocale: moment(),
      logo: require("@/../static/images/index/logo.jpg"),
      BarFixed: false,
      mobileFixed: false,
      langList: [
        { name: "CN", lang: "中文简体" },
        { name: "CNTW", lang: "中文繁体" },
        { name: "EN", lang: "English" },
        // {name:"FR",lang : "Français"},
        // {name:"JA",lang : "日本語"},
        // {name:"KO",lang : "한국어"},
        // {name:"ES",lang : "Español"},
        // {name:"AR",lang : "العربية"}
      ],
      selected: this.globalVar.lang,
      pcMenu: this.globalmenu.menu,
      mShow: false,
      scrollTop: 0,
    }
  },
  async created () {
    this.getDateInfo();
  },
  async mounted () {
    window.addEventListener("scroll", () => {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    })
    document.addEventListener('click', (e) => {
      if (!this.mShow) {
        this.mShow = e.target.id == 'mMenu' ? true : false;
      } else {
        this.mShow = false
      }
    })
  },
  destroyed () {//离开该页面需要移除这个监听的事件
    window.removeEventListener('scroll');
    window.removeEventListener('click');
    window.removeEventListener('touchstart');
    window.removeEventListener('touchmove');
  },
  computed: {
    dateInfo () {
      return this.$store.state.home.dateInfo
    }
  },
  watch: {
    'scrollTop' (val) {
      if (val > this.$refs.pcMenu.offsetHeight) this.BarFixed = true
      else this.BarFixed = false
    }
  },
  methods: {
    menuHandle (item) {//PC一级菜单
      console.log(item, this.globalVar.lang)
      // return
      if (item.name === "云上投洽会" && this.globalVar.lang == 'CNTW') {

        window.location.href = 'https://www.chinafair.org.cn/CifitSystem/newapp.html'
      }
      else {
        this.$router.push({ path: item.link })
      }

    },
    mMenuHandle (item) {//移动一级菜单
      this.$router.push({ path: item.link })
      this.mShow = false;
    },
    subMenuHandle (item) {//头部子页面
      // console.log(item)subName
      console.log(item.subName, this.globalVar.lang)
      if (item.name == "云上投洽会") {
        this.flagItem = true
      } else {
        this.flagItem = false
      }
      if (item.subName === "在线报名" || item.subName === "投资商报名") {
        window.location.href = this.globalVar.SelfServicelogin;
      }
      // else if(item.subName === "国际投资论坛"){
      //     window.location.href = this.globalVar.iiforum;
      // }
      else if (item.subName === "报馆系统") {
        // window.location.href = 'http://baoguan.huizhuozz.com'
        // window.location.href = 'http://zhuchang.phenixexhibition.com'
        // window.location.href = 'http://zhuchang.phenixexhibition.com:1023/'  //EX  main里也要改
        window.location.href = 'https://zc.phenixexhibition.com'  //EX  main里也要改

      }

      else {
        this.$router.push({
          name: item.pathName,
          query: {
            name: item.subName,
          }
        })
      }
    },
    langType (type) {
      this.selLang(type)
    },
    mobilelangType () {
      this.selLang(this.selected)
    },
    selLang (type) {
      // 中文简体：CN,中文繁体：CNTW,英文：EN,法语：FR,日语：JA,韩语：KO,西语：ES,阿语：AR)
      switch (type) {
        case "CN":
          window.location.href = this.globalVar.imgUrl + "/CifitSystem/china/#/index";
          break;
        case "CNTW":
          window.location.href = this.globalVar.imgUrl + "/CifitSystem/chinatw/#/index";
          break;
        case "EN":
          window.location.href = this.globalVar.imgUrl + "/CifitSystem/english/#/index";
          break;
        case "FR":
          window.location.href = this.globalVar.imgUrl + "/CifitSystem/french/#/index";
          break;
        case "JA":
          window.location.href = this.globalVar.imgUrl + "/CifitSystem/japanese/#/index";
          break;
        case "KO":
          window.location.href = this.globalVar.imgUrl + "/CifitSystem/korean/#/index";
          break;
        case "ES":
          window.location.href = this.globalVar.imgUrl + "/CifitSystem/spanish/#/index";
          break;
        case "AR":
          window.location.href = this.globalVar.imgUrl + "/CifitSystem/arabic/#/index";
          break;
      }
    },
    async getDateInfo () {
      await this.$store.dispatch('dateinfo');
    },
  }
}
</script>

<style lang="less">
@import "../static/public.less";
@import "../static/function.less";
.bar {
  border-bottom: 1px solid #e4e4e4;
  line-height: 30px;
  .langbar ul li {
    float: left;
    margin-left: 15px;
    cursor: pointer;
  }
}
.logoBox {
  .flexcontentitems(space-between, center);
}
.logoBar {
  margin: 20px auto;
  .date {
    border: 1px solid #e4e4e4;
    border-radius: 20px;
    padding: 10px 0px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #5d5c5c;
    p {
      display: inline-block;
      text-align: right;
    }
    span {
      font-size: 50px;
      color: #ea0e1e;
    }
  }
}
.menuBar {
  background: #ea0e1e;
}
.menuBar > .pcMenuUl {
  position: relative;
  color: #fff;
  // display: flex;
}
.pcMenuUl
{
  display: flex;
}
.pcMenuUl > li {
  float: left;
  cursor: pointer;
  position: relative;
  color: #fff;
  width: 11%;
  padding: 16px 0px;
  flex: 1;
  span {
    display: block;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
  &.active,
  &:hover {
    background-color: #ff4e4e;
  }
  &:hover {
    .subUl {
      display: block;
    }
  }
}
a.pclink,
a.pclink:hover {
  color: #fff;
}
.mobilelink {
  color: #000;
  display: block;
}
.subUl {
  display: none;
  position: absolute;
  top: 57px;
  left: 0px;
  z-index: 99;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  min-width: 200px;
  background-color: #fff;
  color: #000;
  li {
    padding: 13px;
    border-bottom: 1px solid #f5f5f5;
    i {
      font-size: 14px;
      line-height: 20px;
      display: block;
    }
    &.active {
      i {
        color: #000;
        font-weight: bold;
      }
    }
    &:hover {
      i {
        color: #000;
        font-weight: bold;
      }
    }
  }
}
.mobilemenuBar {
  background-color: #fff;
  height: 56px;
  line-height: 56px;
  position: relative;
  z-index: 999;
  width: 100%;
  ul {
    position: relative;
    z-index: 9999;
  }
}
.BarFixed,
.mobileFixed {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
}
.mMenu {
  ul {
    position: fixed;
    width: 100%;
    background-color: #fff;
    z-index: 999999;
    top: 56px;
    border-top: 1px solid #e4e4e4;
    li {
      padding: 10px;
      border-bottom: 1px solid #e4e4e4;
      font-size: 16px;
      &.active {
        background-color: #ff4e4e;
        color: #fff;
      }
    }
  }
}
.mobileMenuHeight {
  display: none;
}

@media (width: 768px) {
  .pcMenuUl > li span {
    display: block;
    font-size: 14px;
    padding: 18px 10px;
    padding: 2% 1%;
  }
}
@media (max-width: 991px) {
  .pcMenuUl > li span {
    font-size: 12px;
  }
  .subUl a {
    font-size: 12px;
  }
}
@media (min-width: 320px) and (max-width: 767px) {
  .bannerTip,
  .menuBar,
  .logoBar,
  .serverBar,
  .bar,
  .pcMenuHeight {
    display: none;
  }
  .mobilemenuBar,
  .dateBar,
  .mobileMenuHeight {
    display: block;
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
<style scoped>
.flex_row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/App.vue